import { ArrowDown, ArrowUp } from '@travel/icons/ui';
import cx from '@travel/ui/utils/classnames';

import IconTextButton from 'components/IconTextButton';

import styles from './collapsibleSection.module.scss';

import type { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  className?: string;
  isOpen: boolean;
  textDisplayedWhileClosed: ReactNode;
  textDisplayedWhileOpen: ReactNode;
  onClickOpen?: () => void;
  onClickClose?: () => void;
};

const CollapsibleSection = (props: Props) => {
  const {
    children,
    className,
    isOpen,
    textDisplayedWhileClosed,
    textDisplayedWhileOpen,
    onClickOpen,
    onClickClose,
  } = props;
  return (
    <>
      {!isOpen && (
        <IconTextButton
          icon={<ArrowDown spacing={4} size={16} />}
          iconPosition={'right'}
          text={textDisplayedWhileClosed}
          onClick={onClickOpen}
          className={cx(styles.defaultButtonWrapper, className)}
          data-testid="collapsibleSection-iconTextButton-open"
        />
      )}
      {isOpen && (
        <>
          {children}
          <IconTextButton
            icon={<ArrowUp spacing={4} size={16} />}
            iconPosition={'right'}
            text={textDisplayedWhileOpen}
            onClick={onClickClose}
            className={cx(styles.defaultButtonWrapper, className)}
          />
        </>
      )}
    </>
  );
};

export default CollapsibleSection;
